import get from 'lodash/get';
import {
  SET_IS_ACCEPTING_TERMS,
  SET_IS_FETCHING_TERMS,
  SET_RAW_TEXT_TERMS,
  SET_ARE_TERMS_ACCEPTED,
  SET_ARE_DATA_AGGREGATION_TERMS_ACCEPTED,
} from './TermsActions';

const { ADV } = window;

const initialState = {
  isAcceptingTerms: false,
  isFetchingTerms: false,
  areTermsAccepted: !get(ADV, 'data.user.PromptForTermsAndConditions', false),
  areDataAggregationTermsAccepted: !get(
    ADV,
    'data.user.PromptForDataAggregationTermsAndConditions',
    false,
  ),
  termsRawText: {
    clientTCs: '',
    dataAggregationTCs: '',
    advisorTCs: '',
  },
};

export default (state = initialState, { type, ...action }) => {
  switch (type) {
    case SET_IS_ACCEPTING_TERMS:
      return {
        ...state,
        isAcceptingTerms: action.isAcceptingTerms,
      };
    case SET_IS_FETCHING_TERMS:
      return {
        ...state,
        isFetchingTerms: action.isFetchingTerms,
      };
    case SET_RAW_TEXT_TERMS:
      return {
        ...state,
        termsRawText: {
          ...state.termsRawText,
          ...action.termsRawText,
        },
      };
    case SET_ARE_TERMS_ACCEPTED:
      return {
        ...state,
        areTermsAccepted: action.areTermsAccepted,
      };
    case SET_ARE_DATA_AGGREGATION_TERMS_ACCEPTED:
      return {
        ...state,
        areDataAggregationTermsAccepted: action.areDataAggregationTermsAccepted,
      };
    default:
      return state;
  }
};
